import { Component, OnInit } from '@angular/core';
import { InputTextControlComponent } from '../input-text-control/input-text-control.component';

@Component({
  selector: 'app-input-email-control',
  templateUrl: './input-email-control.component.html',
  styleUrls: ['./input-email-control.component.scss']
})
export class InputEmailControlComponent {

  

}
